import {createRef, useEffect, useState} from "react";
import {Link, useNavigate, useParams} from "react-router-dom";
import {BreadCrumbs} from "../../../components/open/pages";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON, PostUploadJSON, ServerImage} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {
    ThinCameraIcon,
    ThinEditIcon,
    ThinInfoIcon,
    ThinnerPeopleIcon,
    ThinnerSMSIcon
} from "../../../components/icons/material-icons";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {GregorianToPersian} from "../../../components/techaran/date-convert";
import {AdminsAddEditNewsModal} from "./add-edit-news";
import {ConfirmModal} from "../../../components/template/confirm-modal";

interface signupInterface {
    id: number,
    name: string,
    studentId: number,
    class: string,
    createdAt: string,
}

export const AdminsNewsDetailsScreen = () => {
    const {newsId} = useParams();
    const [loaded, setLoaded] = useState(false);
    const [data, setData] = useState({
        title: '',
        body: '',
        category: '',
        img: '',
        classes: [] as { id: number, name: string }[],
        students: [] as signupInterface[],
        createdAt: '2000-01-01 00:00:00',
        hasSignup: false,
        isForAll: false,
        canAdd:false,
    });
    const [tab, setTab] = useState('info' as 'info' | 'signup');
    const [addEdit, setAddEdit] = useState(false);
    const imgRef = createRef<any>();
    const onPhotoSelected = () => {
        const c = imgRef.current as HTMLInputElement;
        const x = c.files;
        if (x === null || x!.length !== 1) {
            c.value = '';
            return;
        }
        const fileSize = x[0].size / 1048576;
        const ext = x[0].name.split('.')[x[0].name.split.length - 1].toLowerCase();
        if (fileSize > 10) {
            c.value = '';
            ShowSnackbar(
                'اندازه حجم تصویر باید کمتر از ۱۰ مگابایت باشد.',
                'باشه',
                5000,
            );
            return;
        }
        if (ext !== 'jpg' && ext !== 'png' && ext !== 'jpeg') {
            c.value = '';
            ShowSnackbar(
                'پسوند فایل تصویر باید JPG یا PNG باشد.',
                'باشه',
                5000,
            );
            return;
        }
        ShowProgressLoading();
        PostUploadJSON(
            Apis.server + '/core/admins/news/change-photo',
            {
                id: newsId as string,
                img: x![0],
            },
            true,
            (d: {
                result: string,
                reason: string | undefined,
                photo: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                ShowSnackbar(
                    'تصویر جدید برای اطلاعیه ذخیره شد.',
                    'باشه',
                    5000,
                );
                fetchData();
                window.scrollTo({top: 0, behavior: 'smooth'});
            },
            () => {
                HideProgressLoading();
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    const openPhotoPicker = () => {
        (imgRef.current as HTMLInputElement).click();
    };
    const navigate = useNavigate();
    const fetchData = () => {
        PostJSON(
            Apis.server + '/core/admins/news/get',
            {
                id: newsId as string,
            },
            true,
            (d: {
                result: string,
                reason: string,
                title: string,
                body: string,
                img: string,
                category: string,
                createdAt: string,
                isForAll: 0 | 1,
                classes: { id: number, name: string }[] | null,
                signups: signupInterface[] | null,
                hasSignup: 0 | 1,
                canEdit:boolean,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    else if(d.reason === 'access'){
                        ShowSnackbar(
                            'شما به این بخش دسترسی ندارید.',
                            'باشه',
                            5000,
                        );
                        navigate('/admins',{replace:true});
                    }
                    return;
                }
                setLoaded(true);
                document.title = `${d.title} | اطلاعیه‌ها | اتوماسیون`;
                setData({
                    title: d.title,
                    body: d.body,
                    category: d.category,
                    img: d.img,
                    classes: d.classes === null ? [] : d.classes,
                    students: d.signups === null ? [] : d.signups,
                    createdAt: d.createdAt,
                    hasSignup: d.hasSignup === 1,
                    isForAll: d.isForAll === 1,
                    canAdd: d.canEdit,
                });
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        fetchData();
    }, []);
    const [confirmSMS, setConfirmSMS] = useState(false);
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'اطلاعیه‌ها', url: '/admins/news'},
                {title: !loaded ? '...' : data.title, url: `/admins/news/view/${newsId}`},
            ]}/>
            {
                loaded ?
                    <div className="container" data-aos={"fade-up"} data-aos-duration={1000}>
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="d-none d-lg-block" style={{height: 60}}/>
                                <div className="student-profile">
                                    {
                                        data.canAdd ?
                                            <button className={"student-profile-picker open-tooltip"}
                                                    onClick={openPhotoPicker}>
                                                <ThinCameraIcon/>
                                                <i>تصویر جدید</i>
                                            </button> : null
                                    }
                                    <i style={{
                                        backgroundImage: `url(${ServerImage(data.img, 500, 0)})`,
                                        width: '100%',
                                        borderRadius: 10
                                    }}/>
                                    <b>{data.title}</b>
                                    <span>{data.category}</span>
                                </div>
                            </div>
                            <div className="col-lg-8">
                                <div className="open-tabbar" style={{marginTop: 20}}>
                                    <div className="open-tabbar-inner">
                                        <button onClick={() => {
                                            setTab('info');
                                            window.scrollTo({top: 0, behavior: 'smooth'});
                                        }} className={tab === 'info' ? 'active' : ''}>
                                            <ThinInfoIcon/>
                                            مشخصات
                                        </button>
                                        <button onClick={() => {
                                            setTab('signup');
                                            window.scrollTo({top: 0, behavior: 'smooth'});
                                        }} className={tab === 'signup' ? 'active' : ''}>
                                            <ThinnerPeopleIcon/>
                                            ثبت‌نام ها
                                        </button>
                                    </div>
                                </div>
                                {
                                    tab === 'info' ?
                                        <div className="screen-card">
                                            <div className="screen-card-header">
                                                <b>مشخصات اطلاعیه</b>
                                                <div className="d-flex align-items-center" style={{gap: 10}}>
                                                    <button onClick={() => setConfirmSMS(true)}>
                                                        <ThinnerSMSIcon/>
                                                        <span>ارسال پیامک</span>
                                                    </button>
                                                    {
                                                        data.canAdd ?
                                                            <>
                                                                <button onClick={() => setAddEdit(true)}>
                                                                    <ThinEditIcon/>
                                                                    <span>ویرایش</span>
                                                                </button>
                                                                <button onClick={openPhotoPicker}>
                                                                    <ThinCameraIcon/>
                                                                    <span>آپلود تصویر</span>
                                                                </button>
                                                            </> : null
                                                    }
                                                </div>
                                            </div>
                                            <div className="student-info">
                                                <span>عنوان اطلاعیه:</span>
                                                <b>{data.title}</b>
                                                <span>دسته‌بندی:</span>
                                                <b>{data.category}</b>
                                                <span>تعداد ثبت‌نام:</span>
                                                <b>{CurrencyFormat(data.students.length)} نفر</b>
                                                <span>نوع:</span>
                                                <b>{data.isForAll ? 'همگانی' : 'کلاس‌های خاص'}</b>
                                                <span>کلاس های هدف:</span>
                                                <b>
                                                    {
                                                        data.classes.map((c, i) =>
                                                            <strong key={"KwwWi3422947s4" + i}>
                                                                {c.name}
                                                            </strong>
                                                        )
                                                    }
                                                </b>
                                                <span>متن اطلاعیه:</span>
                                                <b style={{
                                                    lineHeight: '40px',
                                                    textAlign: 'justify',
                                                    marginBottom: 0
                                                }}>{data.body}</b>
                                            </div>
                                        </div> :
                                        <div className={"screen-card"}>
                                            <div className="screen-card-header">
                                                <b>دانش‌آموزان ثبت‌نام شده</b>
                                            </div>
                                            <table
                                                className="table open-table table-striped table-hover table-bordered">
                                                <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>دانش‌آموز</th>
                                                    <th>کلاس</th>
                                                    <th>زمان ثبت‌نام</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    data.students.map((s, i) =>
                                                        <tr key={"Kw1Ww2OsSs1pp02" + i}>
                                                            <td>{StringDigitsConvertToPersian(i + 1)}</td>
                                                            <td>
                                                                <Link
                                                                    to={`/admins/students/view/${s.studentId}`}>
                                                                    {s.name}
                                                                </Link>
                                                            </td>
                                                            <td>{s.class === '' ? '-' : s.class}</td>
                                                            <td>{StringDigitsConvertToPersian(s.createdAt.split(' ')[1] + " " + GregorianToPersian(s.createdAt.split(' ')[0]).replaceAll('-', '/'))}</td>
                                                        </tr>
                                                    )
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                }
                            </div>
                        </div>
                    </div> :
                    null
            }
            <input
                style={{display: 'none'}}
                type="file"
                ref={imgRef}
                onChange={onPhotoSelected}
                accept={".png,.jpg,.jpeg"}
            />
            <AdminsAddEditNewsModal
                active={addEdit}
                closeHandler={() => setAddEdit(false)}
                isEdit={true}
                onDone={() => {
                    ShowProgressLoading();
                    fetchData();
                    window.scrollTo({top: 0, behavior: 'smooth'});
                }}
                newsId={newsId as string}
            />
            <ConfirmModal
                active={confirmSMS}
                closeHandler={() => setConfirmSMS(false)}
                title={"ارسال پیامک اطلاع‌رسانی"}
                desc={"آیا مطمئن هستید می‌خواهید به تمام دانش‌آموزان هدف، یک پیامک اطلاع‌رسانی ارسال کنید؟"}
                icon={<ThinnerSMSIcon/>}
                onOkay={() => {
                    ShowProgressLoading();
                    PostJSON(
                        Apis.server + '/core/admins/news/sms',
                        {
                            id: newsId as string,
                        },
                        true,
                        (d: {
                            result: string,
                            reason: string,
                            count: number,
                        }) => {
                            HideProgressLoading();
                            if (d.result !== 'OK') {
                                if (d.reason === 'login')
                                    AuthRedirectAdmins();
                                return;
                            }
                            ShowSnackbar(
                                'تعداد ' + CurrencyFormat(d.count) + " پیامک ارسال گردید.",
                                'باشه',
                                5000,
                            );
                            setConfirmSMS(false);
                        },
                        () => {
                        },
                        AuthRedirectAdmins,
                    ).then(void 0);
                }}
            />
        </>
    );
};